import React, { useRef, useEffect, useState } from "react";
import "./CoverArt.css";
import FuzzyText from "./FuzzyText";

import uno from "../assets/covers/44.jpg";
import dos from "../assets/covers/CALLEJERO-REMIX.jpg";
import dg from "../assets/covers/dg.jpg";
import byp from "../assets/covers/byp.jpg";
import dgr from "../assets/covers/dgr.jpg";
import lf from "../assets/covers/lf.jpg";
import oc from "../assets/covers/oc.jpg";
import z from "../assets/covers/z.jpg";
import bo from "../assets/covers/bo.jpg";

// Video WebM
import fondoVideo from "../assets/fondorop.webm";

const CoverArt = () => {
  const images = [uno, dos, dg, byp, dgr, lf, oc, z, bo];

  const [expanded, setExpanded] = useState(false);
  const cardRefs = useRef([]);
  const videoRef = useRef(null); // ⭐ necesario para reiniciar autoplay en iOS

  useEffect(() => {
    cardRefs.current = cardRefs.current.slice(0, images.length);
  }, [images.length]);

  // ⭐ FIX AUTOPLAY MOBILE (iOS especialmente)
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    const tryPlay = () => v.play().catch(() => {});
    v.addEventListener("loadeddata", tryPlay);

    const onVisibility = () => {
      if (document.visibilityState === "visible") v.play().catch(() => {});
    };
    document.addEventListener("visibilitychange", onVisibility);

    const unlock = () => {
      v.play().catch(() => {});
      window.removeEventListener("touchstart", unlock);
    };
    window.addEventListener("touchstart", unlock);

    return () => {
      v.removeEventListener("loadeddata", tryPlay);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("touchstart", unlock);
    };
  }, []);

  // Animación de aparición
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 }
    );

    cardRefs.current.forEach((ref) => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, []);

  // Todas las imágenes que se van a mostrar
  const visibleImages = expanded ? images : images.slice(0, 6);

  return (
    <section className="section cover-art" id="cover-art">
      <video
        ref={videoRef}
        className="cover-video"
        autoPlay
        loop
        muted
        playsInline
        webkit-playsinline="true"
      >
        <source src={fondoVideo} type="video/webm" />
        Tu navegador no soporta videos de fondo
      </video>

      {/* Encabezado */}
      <div className="section-header">
        <FuzzyText
          fontSize="clamp(3rem, 8vw, 6rem)"
          fontWeight={900}
          color="#ffffffff"
          fontFamily="Akira Expanded"
        >
          Cover Art
        </FuzzyText>
        <p>Arte visual creado para artistas y marcas.</p>
      </div>

      {/* Grid */}
      <div className={`cover-grid ${expanded ? "expanded" : "collapsed"}`}>
        {visibleImages.map((src, i) => (
          <div
            key={i}
            ref={(el) => (cardRefs.current[i] = el)}
            className={`tilt-card ${expanded ? "visible" : ""}`}
            style={{ transitionDelay: `${i * 0.07}s` }}
          >
            <div className="tilt-inner">
              <img src={src} alt={`cover-${i}`} />
            </div>
          </div>
        ))}
      </div>

      {/* Botón Ver más */}
      {images.length > 6 && (
        <div className="toggle-btn-wrapper">
          <button className="toggle-btn" onClick={() => setExpanded((p) => !p)}>
            {expanded ? "Ver menos" : "Ver más"}
          </button>
        </div>
      )}
    </section>
  );
};

export default CoverArt;
